import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Cover from './Cover';
import VenueInfo from './VenueInfo'; 
import Hotels from './Hotels';
import Countdown from './Countdown';

const HomePage:  React.FC = () => {
    return (
      <div className="App">
        <Navbar/>
        <Cover/>
        <Countdown />
        <VenueInfo/>
        <Hotels/>
        <Footer />
      </div>
    );
  };

export default HomePage;